/**
 * Desktop nav helpers: sidebar cart opens the same drawer as the header toggle.
 */
(function () {
  function sourceCount() {
    return document.querySelector('#cart-drawer-toggle .thb-item-count');
  }

  function syncCounts() {
    var src = sourceCount();
    if (!src) return;
    document.querySelectorAll('[data-nav-cart-count]').forEach(function (el) {
      el.innerHTML = src.innerHTML;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-drawer-open]');
    if (!btn) return;
    var primary = document.getElementById('cart-drawer-toggle');
    if (!primary || btn === primary) return;
    e.preventDefault();
    primary.click();
  });

  document.addEventListener('cart:refresh', syncCounts);
  document.addEventListener('cart-drawer:open', syncCounts);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCounts);
  } else {
    syncCounts();
  }
})();
